import Decimal from 'decimal.js-light';

import { logger } from '@/lib/logger';

type BigNumberLike = { _hex: string };
type NumStrDecimal = number | Decimal | string | BigNumberLike;

export const createDecimal = (value: NumStrDecimal): Decimal => {
  let newDecimal;
  try {
    let useValue: string | number | Decimal = value as string | number | Decimal;
    if (typeof value === 'object' && '_hex' in value && typeof value._hex === 'string') {
      useValue = value._hex;
    }
    newDecimal = new Decimal(`${useValue}`);
  } catch (e) {
    logger.debug('Error instantiating WrappedDecimal', e);
    throw e;
  }

  return newDecimal;
};
